export default __webpack_public_path__ + "static/media/bet13.63d7ea4c.png";